const lightColors = {
  // Primary colors
  primary: '#2563eb',
  primaryDark: '#1e40af',
  primaryLight: '#3b82f6',
  
  // Semantic colors
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  
  // Neutral colors
  background: '#ffffff',
  surface: '#f8fafc',
  border: '#e2e8f0',
  input: '#f1f5f9',
  
  // Text colors
  onBackground: '#0f172a',
  onSurface: '#334155',
  muted: '#64748b',
  
  // Glassmorphism
  glass: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(255, 255, 255, 0.18)',
};

const darkColors = {
  // Primary colors
  primary: '#3b82f6',
  primaryDark: '#2563eb',
  primaryLight: '#60a5fa',
  
  // Semantic colors
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  
  // Neutral colors
  background: '#0f172a',
  surface: '#1e293b',
  border: '#334155',
  input: '#1e293b',
  
  // Text colors
  onBackground: '#f8fafc',
  onSurface: '#e2e8f0',
  muted: '#94a3b8',
  
  // Glassmorphism
  glass: 'rgba(15, 23, 42, 0.7)',
  glassBorder: 'rgba(255, 255, 255, 0.1)',
};

export const getTheme = (mode: 'light' | 'dark' = 'light') => ({
  colors: mode === 'light' ? lightColors : darkColors,
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    full: '9999px',
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  },
  transitions: {
    default: 'all 0.2s ease-in-out',
  },
  breakpoints: {
    xs: '480px',    // Small tablets (portrait)
    sm: '640px',    // Medium tablets (portrait)
    md: '768px',    // Large tablets (portrait)
    lg: '1024px',   // Tablets (landscape)
    xl: '1280px',   // Large tablets (landscape)
    '2xl': '1536px', // Extra large screens
  },
  zIndices: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
});

export const theme = getTheme('light');
export type Theme = ReturnType<typeof getTheme>;
